import {
  ComponentParams,
  ComponentRendering,
  LayoutServiceData,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ImportedData } from 'lib/imported-data/ImportedData.types';

/** Mirrors the fragment defined in the integrated GraphQL query. */
export interface PageItem {
  name?: string;
  navigationTitle?: {
    value?: string;
  };
  url?: {
    path?: string;
  };
  excludeFromBreadcrumb?: {
    boolValue?: boolean;
  };
  isSiteRoot?: {
    boolValue?: boolean;
  };
}

/** See?: integrated GraphQL query on rendering. */
export interface QueryResult {
  currentPage?: PageItem & {
    ancestors?: Array<PageItem>;
  };
}

export interface BreadcrumbModel {
  ancestors?: Array<PageItem>;
  currentPage?: PageItem;
}

export interface N05BreadcrumbProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
  fields?: {
    data?: QueryResult;
  };
  importedData: ImportedData;
  layoutData: LayoutServiceData;
}
